import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function OnBoarding() {

    const navigate = useNavigate()

    return (
        <div className="MuiContainer-root MuiContainer-maxWidthLg css-2jualf">
            <div className="MuiBox-root css-k3gutg">
                <div className="MuiBox-root css-0">
                    <a
                        className="MuiButtonBase-root css-1b47e06"
                        tabIndex={0}
                        data-id="solflare_logo"
                        href="/"
                    >
                        <img
                            src="/assets/logo.26659b6d..svg"
                            alt="Solflare logo"
                            className="solriseLogoImage"
                        />
                    </a>
                    <div className="MuiBox-root css-1kaojm3">
                        <a
                            className="MuiButtonBase-root css-1b47e06"
                            tabIndex={0}
                            data-id="solflare"
                            href="/"
                        >
                            <img src="/assets/solflare.18da1228..svg" alt="Solflare" />
                        </a>
                    </div>
                </div>
                <div className="MuiBox-root css-0">
                    <button
                        className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                        tabIndex={0}
                        type="button"
                        data-id="translate_button"
                    >
                        <svg
                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                            focusable="false"
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            data-testid="TranslateIcon"
                        >
                            <path d="m12.87 15.07-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z" />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="MuiBox-root css-mro3c9">
                <div
                    className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 css-1nofj1x"
                    style={{ minHeight: "calc(100vh - 50px)", marginTop: "-10vh" }}
                >
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-6 css-hp2p99">
                        <div className="MuiBox-root css-i3pbo">
                            <img
                                src="/assets/onboarding-create-wallet.f3c80085..svg"
                                alt="wallet"
                            />
                        </div>
                        <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                            Create a new Solflare wallet
                        </h2>
                        <p className="MuiTypography-root MuiTypography-body2 MuiTypography-gutterBottom css-11xgnsc">
                            Get started with the Solana blockchain within minutes.
                        </p>
                        <div className="MuiBox-root css-178yklu">
                            <button
                                className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root css-7nmrms"
                                tabIndex={0}
                                type="button"
                                data-id="i_need_a_wallet_button"
                                onClick={() => navigate("/create")}
                            >
                                I NEED A NEW WALLET
                            </button>
                        </div>
                    </div>
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-6 css-hp2p99">
                        <div className="MuiBox-root css-i3pbo">
                            <img
                                src="/assets/onboarding-access-wallet.471e4067..svg"
                                alt="wallet"
                            />
                        </div>
                        <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                            Already have your Recovery Phrase?
                        </h2>
                        <p className="MuiTypography-root MuiTypography-body2 MuiTypography-gutterBottom css-11xgnsc">
                            Restore your existing wallet in two easy steps.
                        </p>
                        <div className="MuiBox-root css-178yklu">
                            <button
                                className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root css-7nmrms"
                                tabIndex={0}
                                type="button"
                                data-id="i_already_have_wallet_button"
                                onClick={() => navigate("/access")}
                            >
                                I ALREADY HAVE A WALLET
                            </button>
                        </div>
                    </div>
                    {/* <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 css-12k1ydq">
                        <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                            or continue with
                        </h2>
                        <div className="MuiBox-root css-8csw11">
                            <button
                                className="MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButtonBase-root css-11qtv4f"
                                tabIndex={0}
                                type="button"
                                data-id="ledger_button"
                            >
                                <span className="MuiButton-startIcon MuiButton-iconSizeMedium css-1l6c7y9">
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                        focusable="false"
                                        aria-hidden="true"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M5.75078 6.17553C4.54853 6.06967 3.54164 7.07779 3.65185 8.28753C3.732 9.215 4.4784 9.96605 5.40013 10.0467C6.60238 10.1526 7.60927 9.14444 7.49906 7.93469C7.4139 7.00218 6.67251 6.25618 5.75078 6.17553ZM5.67063 9.29565C4.94427 9.35614 4.33814 8.74623 4.39825 8.01534C4.44333 7.44071 4.90921 6.97194 5.48028 6.92657C6.20664 6.86609 6.81277 7.476 6.75266 8.20689C6.70257 8.78151 6.2417 9.24525 5.67063 9.29565Z" />
                                        <path d="M24 3.42845C24 3.19154 23.8096 3 23.5742 3H5.09956C2.40952 3 0.195366 5.11201 0.0100188 7.77345L0 8.37328C0.120225 11.1003 2.36443 13.2778 5.09956 13.2778H7.28867L19.2461 20.7984C19.8673 21.1865 20.6888 20.995 21.0745 20.3699C23.5993 16.2719 24.4408 15.8384 22.5573 14.5329C21.886 14.0692 20.4734 13.2526 19.0708 12.3705L23.5742 12.3604C23.8096 12.3604 24 12.1689 24 11.932V3.42845ZM5.09956 12.5217C2.80526 12.5217 0.916719 10.7222 0.756418 8.45393H2.10895C2.22417 9.48222 2.79023 10.4551 3.732 11.0398L6.08641 12.5217H5.09956ZM22.5322 15.4755C22.8028 15.6418 22.8879 15.9997 22.7176 16.2719L20.4383 19.9717C20.273 20.2439 19.9173 20.3246 19.6468 20.1582C19.6468 20.1582 4.82905 10.8381 4.12774 10.3996C2.85034 9.59815 2.4546 7.89947 3.2511 6.60907C4.04759 5.31364 5.73576 4.92047 7.01816 5.72193C13.4602 9.76953 16.1152 11.443 22.5322 15.4755ZM21.6907 11.6043H17.8635L12.8591 8.45393H21.6907V11.6043ZM21.6907 7.69784H11.5817L7.4139 5.07673C5.19975 3.6956 2.35942 5.15234 2.10394 7.69784H0.766437C0.98685 5.49006 2.85034 3.75609 5.09956 3.75609H21.6907V7.69784ZM23.2987 11.6043H22.4922V3.79137H23.2987V11.6043Z" />
                                    </svg>
                                </span>
                                Ledger
                            </button>
                            <button
                                className="MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButtonBase-root css-11qtv4f"
                                tabIndex={0}
                                type="button"
                                data-id="keystone_button"
                            >
                                <span className="MuiButton-startIcon MuiButton-iconSizeMedium css-1l6c7y9">
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                        focusable="false"
                                        aria-hidden="true"
                                        viewBox="18 18 50 50"
                                    >
                                        <path d="M41.0085945,48.778948 C41.2360681,48.9112688 41.4457322,49.0720682 41.6325097,49.2574522 L49.2185789,56.786927 C50.8721152,58.4281274 50.8821154,61.0990393 49.240915,62.7525756 C49.2301043,62.7634675 49.2192343,62.7743004 49.2083054,62.7850737 L48.0907648,63.8867034 C46.9372807,65.0237647 45.1974733,65.321678 43.7313913,64.6331741 L35.360307,60.701931 C33.42679,59.7939093 32.5954617,57.4903871 33.5034833,55.5568701 C33.5516101,55.4543903 33.6042133,55.3540731 33.661141,55.2562082 L36.7781425,49.8977512 C37.6374006,48.4205951 39.5314384,47.9196899 41.0085945,48.778948 Z M44.3106765,20.3112406 C44.661798,20.5140267 44.9536598,20.8052708 45.1571894,21.1559618 L46.6358418,23.7037492 C47.3332793,24.9054666 47.3325454,26.3889405 46.6339192,27.5899672 L30.1056085,56.0042228 C29.7768415,56.5694149 29.0521444,56.7610753 28.4869523,56.4323083 C28.3109228,56.3299135 28.1642815,56.183844 28.0611999,56.0082158 C27.3806266,54.8486693 26.8612304,53.6017931 26.5173448,52.3019966 L26.2482637,51.284941 C25.7439909,49.3789233 26.0144008,47.3508023 27.0004399,45.6434882 L41.1404653,21.1602172 C41.7814566,20.0503491 43.2008085,19.6702494 44.3106765,20.3112406 Z M50.8751117,31.8169799 C51.339613,32.0871693 51.7257415,32.4736708 51.9954824,32.9384327 L55.2370099,38.5235642 C56.0948182,40.0015626 55.5920549,41.8951081 54.1140565,42.7529164 C53.6422304,43.0267573 53.1063922,43.1709877 52.5608571,43.1709877 L45.3981588,43.1709877 C43.9028777,43.1709877 42.6907128,41.9588228 42.6907128,40.4635416 C42.6907128,39.9853119 42.8173833,39.5156148 43.0578382,39.1022322 L46.6446774,32.9358499 C47.5039121,31.4586803 49.3979421,30.9577451 50.8751117,31.8169799 Z" />
                                        <path d="M60.7454926,48.014753 C61.4839531,49.2871285 61.2678338,50.8979706 60.2201077,51.9307016 L56.6151716,55.4840441 C55.2565811,56.8231904 53.0732619,56.8194064 51.7193215,55.4755589 L45.3560138,49.159686 C44.5979626,48.4072857 44.5933817,47.1828228 45.345782,46.4247716 C45.7088639,46.0589629 46.202948,45.8532229 46.7183551,45.8532229 L56.991785,45.8532229 C58.5388375,45.8532229 59.9689285,46.6767247 60.7454926,48.014753 Z" />
                                    </svg>
                                </span>
                                keystone
                            </button>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}
